<!--
 * @Descripttion: 预览
 * @Author: zenghua.wang
 * @Date: 2021-04-19 18:00:24
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-10-15 09:25:06
-->
<template>
  <el-form
    class="widget-preview"
    :label-position="data.labelPosition || 'right'"
    :label-width="setPx(data.labelWidth) || '100px'"
    :label-suffix="data.labelSuffix || ''"
  >
    <el-row>
      <el-col
        v-for="(widget, index) in data.list"
        :md="widget.option.span || 24"
        :xs="24"
        :offset="widget.option.offset || 0"
        :key="index"
      >
        <component
          :is="`drag-${widget.type}`"
          :id="widget.prop"
          :label="widget.label"
          :apiId="widget.apiId"
          :width="widget.width"
          :height="widget.height"
          :option="widget.option"
          :children="widget.children"
          :index="index"
          :disabled="true"
          :page="widget.page"
        ></component>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  name: 'widget-preview',
  components: {},
  props: ['data'],
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.widget {
  &-preview {
    padding: 10px;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>
